// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderClientPhone_wrapper__5+VIP","menuWrapper":"OrderClientPhone_menuWrapper__C2CE5","item":"OrderClientPhone_item__48lno","itemTitle":"OrderClientPhone_itemTitle__uvH1+"};